import { Table } from "antd"
import { ExclamationCircleFilled } from "@ant-design/icons"
import HoverIconSwitch from "@/components/checkout/HoverIconSwitch"
import { createCartColumns } from "@/components/view-cart/cartTableColumns"
import DeleteHover from '@/svgs/checkout/delete-hover.svg'
import DeleteIcon from '@/svgs/checkout/delete.svg'
import WishListHover from '@/svgs/checkout/My-Wishlist-hover.svg'
import WishListIcon from '@/svgs/checkout/My-Wishlist.svg'
import styles from "@/styles/view-cart.module.scss"

interface SoldOutCartTableProps {
  dataSource: any[]
  loadingRows: Record<string | number, boolean>
  onDeleteAvailableList: () => void
  onDeleteItem: (_record: any) => void
  onExpressChange: (_record: any, _event: any) => void
  onMoveAvailableListToWishlist: () => void
  onQtyChange: (_record: any, _value: string | number) => void
  onWishlistItem: (_record: any) => void
}

const SoldOutCartTable = ({
  dataSource,
  loadingRows,
  onDeleteAvailableList,
  onDeleteItem,
  onExpressChange,
  onMoveAvailableListToWishlist,
  onQtyChange,
  onWishlistItem
}: SoldOutCartTableProps) => {
  if (!dataSource.length) return null

  return (
    <div className={styles['table-box']}>
      <div className={styles['table-head']}>
        <div className={styles['table-title']}>
          <ExclamationCircleFilled style={{ color: '#FAAD14' }} />
          <div className={styles["title"]}>Sorry, this item has sold out</div>
        </div>
        <div>
          <HoverIconSwitch
            IconOne={<DeleteIcon className={styles['cart-icon']} onClick={onDeleteAvailableList} />}
            IconTwo={<DeleteHover className={styles['cart-icon']} onClick={onDeleteAvailableList} />}
            hoverContent="Delete"
          />
          <HoverIconSwitch
            IconOne={<WishListIcon className={styles['cart-icon']} onClick={onMoveAvailableListToWishlist} />}
            IconTwo={<WishListHover className={styles['cart-icon']} onClick={onMoveAvailableListToWishlist} />}
            hoverContent="Move to wishlist"
          />
        </div>
      </div>
      <Table
        dataSource={dataSource}
        rowKey="productID"
        columns={createCartColumns({
          disabled: true,
          loadingRows,
          onDeleteItem,
          onExpressChange,
          onQtyChange,
          onWishlistItem
        })}
        pagination={false}
        showHeader={false}
      />
    </div>
  )
}

export default SoldOutCartTable
